export enum SpinnerType {
  DEFAULT,
  AI_STARS,
}
